import VendorPaymentsHtml from './templates/vendor-payments.html';

export function VendorPayments () {
  return {
    controller: 'VendorPaymentsCtrl',
    restrict: 'E',
    templateUrl: VendorPaymentsHtml,
    scope: {
      vendor: '=',
      payments: '='
    }
  }
}